(()=>{
  const reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if(reduce||!('IntersectionObserver' in window)) return;

  const selectors=[
    '.bw-story',
    '.bw-sectionhead',
    '.bw-card',
    '.bw-editorial__media',
    '.bw-editorial__copy',
    '.bw-roots__inner',
    '.bw-newsletter > div',
    '.bw-newsletter__form'
  ];

  const items=[...document.querySelectorAll(selectors.join(','))];
  if(!items.length) return;

  document.documentElement.classList.add('bw-motion-ready');

  document.querySelectorAll('.bw-card').forEach((el,i)=>{
    el.style.setProperty('--bw-delay',`${Math.min(i,5)*70}ms`);
  });

  const media=document.querySelector('.bw-editorial__media');
  if(media) media.classList.add('bw-reveal--soft');

  const observer=new IntersectionObserver(entries=>{
    entries.forEach(entry=>{
      if(entry.isIntersecting){
        entry.target.classList.add('bw-inview');
        observer.unobserve(entry.target);
      }
    });
  },{threshold:.12,rootMargin:'0px 0px -8% 0px'});

  items.forEach(el=>{
    el.classList.add('bw-reveal');
    observer.observe(el);
  });
})();
